import {
  Lutfi_Attributes_GETROW,
  Lutfi_Summary_GETROW,
  Lutfi_Update_GETROW,
} from "../../Server/ApiV2";
import { fAlertToast } from "../../Utility/Utilitys";

export const GetAttributes = async (setTransactionList) => {
  const vAttributes = await Lutfi_Attributes_GETROW({});
  if (vAttributes?.status === 200) {
    setTransactionList(vAttributes?.data?.ResultSet?.TransType);
    return vAttributes?.data?.ResultSet
  } else {
    return [];
  }
};
export const GetSummary = async (vTrnType) => {
  let iTrnType = {
    v_TrnTyp: vTrnType,
  };
  const vSummary = await Lutfi_Summary_GETROW(iTrnType);
  if (vSummary?.status === 200) {
    return vSummary?.data?.ResultSet;
  } else {
    return [];
  }
};
export const GetUpdate = async (vTrnType, v_List) => {
  let iUpdate = {
    v_TrnTyp:vTrnType, v_List:v_List
  };
  const vUpdate = await Lutfi_Update_GETROW(iUpdate);
  if (vUpdate?.status === 200) {
    fAlertToast("SUCCESS", "Successfully Updated....");      
    return true
  } else {
    return  false;
  }
};
